__turbopack_context__.v({
  "pLarge": "SolidBgTextSection-module__1lWpUa__pLarge",
  "root": "SolidBgTextSection-module__1lWpUa__root",
});
